// extracted by mini-css-extract-plugin
module.exports = {"recommendationsContainer":"_3cD5DScbkziPOvuLqF7r0k","tile":"_3mvkBPScqvKIUdfapVpi5m"};